import 'shared/common'
import 'shared/make_model_menu'
import '@carwow/carwow_theme/app/javascript/components/sticky_header'
import '@carwow/carwow_theme/app/javascript/components/button_back_to_top'
import '@carwow/carwow_theme/app/javascript/components/read_more'
import '@carwow/carwow_theme/app/javascript/components/inline_filter/container'
import '@carwow/carwow_theme/app/javascript/components/video'
import '@carwow/carwow_theme/app/javascript/components/media_slider'
import '@carwow/carwow_theme/app/javascript/components/stock_search'
import '@carwow/carwow_theme/app/javascript/components/stock_deal_card'
import '@carwow/carwow_theme/app/javascript/components/envkv_emissions'

import { initGallery } from '@carwow/carwow_theme/app/javascript/components/gallery'
import initOpenGalleryOnIndex from 'shared/gallery'

document.addEventListener('DOMContentLoaded', () => {
  initGallery(document)
  initOpenGalleryOnIndex()
})
